import React from 'react';

import FeeTransparencyEmailTable from './FeeTransparencyEmailTable';

export default () => <FeeTransparencyEmailTable />;
